import { object } from "prop-types";
import { useTranslation } from "react-i18next";
import { MenuButton, PopMenu } from "@components";
import { ExpandMore, FormatListBulletedRounded } from "@material-ui/icons";
import { useTooltipHoverActions } from "@tools";

export const SelectSectionType = ({
  section,
}) => {
  const { t } = useTranslation();
  
  const {
    anchor,
    hover,
    handleHoverIn,
    handleHoverOut,
    handlePopupClose,
    handleTimeoutClear,
  } = useTooltipHoverActions();
  
  const handleSectionTypeChange = (isMaterial) => () => {
    section.setMaterialFirst(isMaterial, true);
  }
  
  return <>
    <MenuButton
      ref={anchor}
      icon={<FormatListBulletedRounded color="primary" />}
      endIcon={<ExpandMore className="-rotate-90 text-lighter" />}
      onMouseEnter={handleHoverIn}
      onMouseLeave={handlePopupClose}
    >
      {t("views.editor.section_type_change")}
    </MenuButton>
    <PopMenu
      anchor={anchor.current}
      show={hover}
      onMouseEnter={handleTimeoutClear}
      onMouseLeave={handleHoverOut}
      placement="right-start"
      offset={0}
    >
      <MenuButton onClick={handleSectionTypeChange(false)}>
        {t("proposal_parts.section_types.workload")}
      </MenuButton>
      <MenuButton onClick={handleSectionTypeChange(true)}>
        {t("proposal_parts.section_types.material")}
      </MenuButton>
    </PopMenu>
  </>;
}

SelectSectionType.propTypes = {
  section: object.isRequired,
}